var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Launch"}},[_c('p',[_vm._v(_vm._s(_vm.message || "你无权观看此直播，请联系管理员"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }